import { render, staticRenderFns } from "./whatsTomPremium.vue?vue&type=template&id=4158da4e&lang=pug"
import script from "./whatsTomPremium.vue?vue&type=script&lang=js"
export * from "./whatsTomPremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports